export default "<div id=\"react-container\"></div>\n"